module.exports = __webpack_public_path__ + "static/media/childWhite.696da38d.svg";